import { ChevronRightIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";

export interface BreadcrumbCrumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  crumbs: BreadcrumbCrumb[];
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ crumbs }) => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center gap-2 mb-2">
      {crumbs.map((crumb, i) => {
        const isLast = i === crumbs.length - 1;
        return (
          <span key={crumb.label} className="flex items-center gap-2">
            {i > 0 && <ChevronRightIcon className="h-3 w-3 text-text-tertiary" />}
            {isLast || !crumb.to ? (
              <span className="text-sm text-text-secondary">{crumb.label}</span>
            ) : (
              <button
                type="button"
                onClick={() => crumb.to && navigate(crumb.to)}
                className="text-sm text-text-secondary hover:text-text-primary transition-colors cursor-pointer"
              >
                {crumb.label}
              </button>
            )}
          </span>
        );
      })}
    </div>
  );
};
